import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CryptoCertificatesComponent } from '@shared/components/signature/crypto/certificates/certificates.component';
import { DefaultLoaderComponent } from '@bazis/shared/components/loaders/default-loader.component';
import { DocumentAccordeonComponent } from '@bazis/shared/components/document-accordeon/document-accordeon.component';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { ToolbarModule } from '@bazis/shared/components/web/toolbar/toolbar.module';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { CryptoSigningComponent } from '@bazis/signature/crypto/components/signing/signing.component';
import { CryptoInfoComponent } from '@shared/components/signature/crypto/info/info.component';
import { LinkModule } from '@bazis/shared/components/web/link/link.module';

@Component({
    selector: 'app-crypto-signing',
    templateUrl: './signing.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DefaultLoaderComponent,
        DocumentAccordeonComponent,
        CommonModule,
        CryptoCertificatesComponent,
        ButtonModule,
        IconModule,
        ToolbarModule,
        ColorDirective,
        TranslocoModule,
        LinkModule,
    ],
})
export class TMSCryptoSigningComponent extends CryptoSigningComponent {
    private translocoService = inject(TranslocoService);

    openAlert() {
        const headerKey = this.allItems.length > 1 ? 'crypto.docsSigned' : 'crypto.docSigned';
        const headerParams =
            this.allItems.length > 1
                ? { docsName: this.translocoService.translate('document.names.documents') }
                : {
                      docName: this.translocoService.translate(
                          'document.names.document.' + this.allItems[0].contextLabel,
                      ),
                  };
        const messageKey =
            this.allItems.length === 1 ? 'crypto.successDocSigned1' : 'crypto.successDocsSignedAll';

        const alert = this.alertService.create({
            icon: 'check-circle-solid',
            headerKey,
            headerParams,
            messageKey,
            //messageParams,
            buttons: [
                {
                    titleKey: 'action.close',
                    handler: () => {
                        this.close();
                    },
                },
            ],
            cssClass: 'tms-alert_secondary tms-alert_success',
            hasCloseIcon: false,
        });

        alert.onDidDismiss().then(() => {
            this.router.navigateByUrl(this.router.url.replace('/edit', ''), {
                replaceUrl: true,
            });
        });
    }
}
